<template>
  <li class="current-user" v-if="comment.user_id === loggedInUserData.id">
    <div class="comment-wrap current-user">
<!--       <div class="comment-header">
        <span class="comment-date">{{ commentDateTime }}</span>
      </div> -->
      <div class="comment-reply" v-if="comment.parent_comment_id">
        <div class="reply-label"><span>{{ getReplyName(comment.parent_comment_id) }}</span> - {{ getReplyDate(comment.parent_comment_id) }} </div>
        <span class="reply-comment">{{ getReplyText(comment.parent_comment_id) }}</span>
      </div>
      <div class="comment">
        <div class="comment-text" v-html="comment.comments"></div>
        <b-button @click="clickReplyIcon" class="comment-button comment-reply-button" :class="{hide: showReplyEditor}">
          <i class="fas fa-reply"></i>
        </b-button>
        <b-button @click="clickDeleteComment" class="comment-button comment-trash-button" :disabled="deleteCommentDisabled">
          <i class="fas fa-trash"></i>
        </b-button>
      </div>
      <div class="comment-date-wrapper"><span class="comment-date">{{ commentDateTime }}</span></div>

      <div class="comment-footer">
        
        <b-collapse v-model="showReplyEditor" :id="`comment-reply-toggle-button-${comment.id}`">
          <div class="collapse-inner">
            <b-button class="comment-reply-toggle-button" @click="clickHideReplyEditor">
              <!--<span class="collapsed">Reply</span>-->
              <span class="not-collapsed"><i class="fas fa-times"></i></span>
            </b-button>
            <div class="comment-reply-wrap">
              <textarea :id="`comment-reply-${comment.id}`" rows="1" :name="`comment-reply-${comment.id}`" v-model="replyText" class="comment-input" placeholder="Reply to this comment" @input="$event => resizeInput($event.target)"
              @keydown.enter.exact.prevent
              @keyup.enter.exact="commentReplySubmitted"
              @keydown.enter.shift.exact="newline"
               ></textarea>
              <div class="comment-controls">
                <b-button @click="commentReplySubmitted" :id="`comment-reply-${comment.id}`" :data-parent-id="comment.id" class="comment-button" :disabled="replyButtonDisabled">
                  <i class="fas fa-paper-plane"></i>
                </b-button>
                <emoji-picker @emoji="insertEmoji" :search="emojiSearch" class="emoji-picker-outer">
                  <button class="emoji-invoker" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                    <!--<button type="button">Open</button>-->
                    <i class="far fa-smile"></i>
                  </button>
                  <div class="emoji-picker" slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                    <div class="emoji-search-wrap">
                      <input type="text" placeholder="Search Emoji" v-model="emojiSearch">
                    </div>
                    <div class="emoji-list-wrap">
                      <div class="emoji-category" v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div class="emoji-category-content">
                          <span
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="insertEmoji(emoji)"
                            :title="emojiName"
                          >{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </li>
  <li class="other-user"  v-else>
    <div class="user-icon-wrap" v-if="false">
      <div class="user-icon">
        <span class="user-icon-inner">
          {{ getInitials(comment.name) }}
        </span>
      </div>
    </div>
    <div class="comment-wrap other-user">
      <div class="comment-reply" v-if="comment.parent_comment_id">
        <div class="reply-label"><span>{{ getReplyName(comment.parent_comment_id) }}</span> {{ getReplyDate(comment.parent_comment_id) }} </div>
        <span class="reply-comment">{{ getReplyText(comment.parent_comment_id) }}</span>
      </div>
      <div class="comment-header">
        <span class="comment-user">{{comment.name}}</span>
        <span class="comment-date">{{ commentDateTime }}</span>
        <!-- <span class="comment-date">{{ commentDateTime }}</span> -->
      </div>
      <div class="comment">
        <div class="comment-text" v-html="comment.comments"></div>
        <b-button @click="clickReplyIcon" class="comment-button comment-reply-button" :class="{hide: showReplyEditor}">
          <i class="fas fa-reply"></i>
        </b-button>
      </div>

      <div class="comment-footer">
        
        <b-collapse v-model="showReplyEditor" :id="`comment-reply-toggle-button-${comment.id}`">
          <div class="collapse-inner">
            <b-button class="comment-reply-toggle-button" @click="clickHideReplyEditor">
              <!--<span class="collapsed">Reply</span>-->
              <span class="not-collapsed"><i class="fas fa-times"></i></span>
            </b-button>
            <div class="comment-reply-wrap">
              <textarea :id="`comment-reply-${comment.id}`" rows="1" :name="`comment-reply-${comment.id}`" v-model="replyText" class="comment-input" placeholder="Reply to this comment" @input="$event => resizeInput($event.target)"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="commentReplySubmitted"
    @keydown.enter.shift.exact="newline"

              	></textarea>
              <b-button @click="commentReplySubmitted" :id="`comment-reply-${comment.id}`" :data-parent-id="comment.id" class="comment-button" :disabled="replyButtonDisabled">
                <i class="fas fa-paper-plane"></i>
              </b-button>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </li>
</template>

<script>
import moment from "moment";
import EmojiPicker from 'vue-emoji-picker';
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      replyText: "",
      //dateFormat: "YYYY-MM-DD HH:mm",
      dateFormat: "MMMM Do YYYY, h:mm a",
      timeFormat: "h:mm a",
      showReplyEditor: false,
      deleteCommentDisabled: false,
      emojiSearch: "",
      emojiInput: "",
    };
  },
  components: {
    EmojiPicker,
  },
  props: ["socialPost", "comment", "commentField"],
  computed: {
    ...mapGetters([
      "deliverableDetail",
      "loggedInUserData"
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    commentDateTime(){
    	if(this.$moment.utc(this.comment.created_at).local().isSame(this.$moment(), 'day')){
    			// return just time if it's today.
    			return this.$moment.utc(this.comment.created_at).local().format(this.timeFormat);
    	} else {
    			return this.$moment.utc(this.comment.created_at).local().format(this.dateFormat);
    	}
    },
    replyButtonClass(){
      let btnClass = {};
      if(this.showReplyEditor){
        btnClass = {
          'hide': true,
        }
      }
    },
    replyButtonDisabled(){
      if(!this.replyText.length){
        return true;
      }
      return false;
    }
  },
  methods: {
  	newline() {
      this.replyText = `${this.replyText}`;
    },
    commentReplySubmitted(e){
      let button = e.target.parentNode;
      let parentId = button.getAttribute("data-parent-id");
      if (parentId == "") {
      		return false;
      }
      let textarea = document.getElementById("comment-reply-"+parentId);
      if (typeof textarea == "undefined") {
      		return false;
      }
      let toggleButton = document.getElementById("comment-reply-toggle-button-"+parentId);

      if (typeof toggleButton == "undefined") {
      	return false;
      }
      let that = this;

      if(!this.replyText.length){
        console.log("Comment must not be empty.");
      } else {
        
        button.setAttribute("disabled", true);
        textarea.setAttribute("disabled", true);
        that.$store.dispatch("createSocialPostComment", {
          id: that.socialPost.id,
          parent_comment_id: parentId,
          field_name: that.commentField,
          comments: that.replyText
        }).then(function(){
          button.removeAttribute("disabled");
          textarea.removeAttribute("disabled");
          that.replyText = "";
          toggleButton.click();
          that.initializeComment;
        });
      }
    },
    clickReplyIcon(){
      //this.showReplyEditor = true;
      this.$emit("clickReply", this.comment);
    },
    clickHideReplyEditor(){
      this.showReplyEditor = false;
    },
    clickDeleteComment(){
      let that = this;
      this.deleteCommentDisabled = true;
      this.$store.dispatch("removeSocialPostComment", {
        id: that.comment.id,
        post_id: that.socialPost.id
      }).then(function(){
        that.deleteCommentDisabled = false;
      });
    },
    filterByField(comment){
      if(comment.field_name == this.commentField){
        return true;
      }
      return false;
    },
    getInitials(name){
      let names = name.split(" ");
      let initials = "";
      names.forEach(function(el){
        initials += el.charAt(0);
      });
      return initials;
    },
    getReplyComment(commentId){
      let parentComment = this.socialPost.comments.filter((el) => el.id == commentId)[0];
      if(parentComment){
        return parentComment;
      }
      return false;
    },
    getReplyText(commentId){
      let parentComment = this.socialPost.comments.filter((el) => el.id == commentId)[0];
      if(parentComment){
        let commentText = parentComment.comments;
        if(commentText.length>50){
          commentText = truncateString(commentText, 50);
        }
        return commentText;
      } else {
        return "Comment deleted"
      }
    },
    getReplyName(commentId){
      return this.getReplyComment(commentId).name;
    },
    getReplyDate(commentId){
      let date = this.getReplyComment(commentId).created_at;
      return this.$moment.utc(date).local().format(this.dateFormat);
    },
    initializeComment(){
      this.replyText = "";
    },
    resizeInput(textArea){
      textArea.style.height = "5px";
      textArea.style.height = (textArea.scrollHeight)+"px";
    },
    insertEmoji(emoji){
      this.replyText += emoji;
    }
  },
  created(){
    this.initializeComment();
  }
}
</script>